/**
 * Application Constants
 * Centralized constants for the VinCentrix application
 */

// Timing Constants
export const TIMING = {
  CONVERSATION_POLL_INTERVAL_MS: 4000, // 4 seconds for near real-time updates
  CUSTOMER_REFRESH_INTERVAL_MS: 4000, // 4 seconds for customer refresh polling
  FADE_OUT_DELAY_MS: 3000,
  TOAST_DURATION_MS: 5000,
  NOTIFICATION_SOUND_DURATION_MS: 300,
  LOADING_SCREEN_MIN_DISPLAY_MS: 5000
};

const configuredApiUrl = process.env.REACT_APP_API_URL || 'https://vincentrix-crm-production.up.railway.app';

// API Configuration
export const API_CONFIG = {
  DEFAULT_URL: configuredApiUrl,
  PRODUCTION_URL: configuredApiUrl,
  OPENAI_API_URL: 'https://api.openai.com/v1/chat/completions'
};

// Validation Constants
export const VALIDATION = {
  VIN_LENGTH: 17,
  MAX_NOTIFICATIONS: 20,
  MAX_DEMO_MESSAGE_LENGTH: 1000
};

// UI Constants
export const UI = {
  MAX_MODAL_WIDTH: '500px',
  MAX_MODAL_HEIGHT: '500px',
  Z_INDEX_MODAL: 10000,
  Z_INDEX_TOAST: 1000,
  PERSPECTIVE_3D: 1000
};

// Animation Constants
export const ANIMATION = {
  TILT_SCALE: 1.02,
  TILT_TRANSLATE_Y: -4,
  GRADIENT_SIZE: 300
};
